/**
 * Styles the Shopify Forms inline form.
 *
 * The app renders into a shadow root (`<shopify-forms-embed>` calls
 * attachShadow({mode: 'open'}) and adopts its own stylesheets), so theme CSS
 * cannot reach the fields — style rules have to be injected inside the shadow
 * root itself. Because the mode is open, that's possible from here.
 *
 * The CSS comes from sections/forms-app-style.liquid via window.eagleFormsCss,
 * so it stays editable through theme settings.
 */
(function () {
  'use strict';

  var TAG = 'shopify-forms-embed';
  var MARK = 'data-eagle-styled';

  function styleRoot(host) {
    var root = host.shadowRoot;
    if (!root || host.getAttribute(MARK) === 'true') return false;
    // Wait until the app has actually rendered the form.
    if (!root.querySelector('form, input, button')) return false;

    var css = window.eagleFormsCss || '';
    if (!css) return false;

    try {
      var sheet = new CSSStyleSheet();
      sheet.replaceSync(css);
      // Last in the list so it wins over the app's own sheets.
      root.adoptedStyleSheets = root.adoptedStyleSheets.concat([sheet]);
    } catch (error) {
      var style = document.createElement('style');
      style.textContent = css;
      root.appendChild(style);
    }

    boldWords(root);

    // The app renders fields progressively, so the terms checkboxes often
    // appear after the first pass. Keep re-applying as the shadow tree fills in.
    if (!host.__eagleBoldObserver) {
      var rerun = new MutationObserver(function () {
        boldWords(root);
      });
      rerun.observe(root, { childList: true, subtree: true });
      host.__eagleBoldObserver = rerun;
      setTimeout(function () {
        rerun.disconnect();
        host.__eagleBoldObserver = null;
      }, 20000);
    }

    host.setAttribute(MARK, 'true');
    return true;
  }

  /**
   * Emphasises the whole statement containing any of the configured words.
   * The app stores field labels as plain text, and CSS cannot select an element
   * by its content, so the match has to be found in JS and the weight applied
   * to the nearest label/list-item/paragraph around it.
   */
  function boldWords(root) {
    var words = window.eagleFormsBoldWords;
    if (!words || !words.length) return;

    var matcher = new RegExp('(' + words.map(escapeRe).join('|') + ')');
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var tag = node.parentNode && node.parentNode.nodeName;
        if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'STRONG') return NodeFilter.FILTER_REJECT;
        return matcher.test(node.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });

    var targets = [];
    var node;
    while ((node = walker.nextNode())) targets.push(node);

    targets.forEach(function (textNode) {
      var el = textNode.parentNode;
      // Walk out to the statement that holds the match, not just the span the
      // text happens to sit in.
      var block = (el && el.closest && el.closest('label, li, p')) || el;
      if (!block || !block.style || block.getAttribute('data-eagle-bold') === '1') return;
      // The app's own sheet sets font-weight with !important, so a plain inline
      // style loses. Set it at the same priority on the statement and on every
      // element inside it.
      embolden(block);
      var kids = block.querySelectorAll ? block.querySelectorAll('*') : [];
      for (var i = 0; i < kids.length; i++) embolden(kids[i]);
      block.setAttribute('data-eagle-bold', '1');
    });
  }

  function embolden(el) {
    if (el && el.style && el.style.setProperty) el.style.setProperty('font-weight', '700', 'important');
  }

  function escapeRe(s) {
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function sweep() {
    var hosts = document.querySelectorAll(TAG);
    var pending = 0;
    for (var i = 0; i < hosts.length; i++) {
      if (!styleRoot(hosts[i])) pending++;
    }
    return hosts.length > 0 && pending === 0;
  }

  if (sweep()) return;

  // The form is injected asynchronously, so watch until it appears. Give up
  // after 20s rather than observing the document forever.
  var observer = new MutationObserver(function () {
    if (sweep()) observer.disconnect();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function () {
    observer.disconnect();
  }, 20000);
})();
